var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "80", height: "80", viewBox: "0 0 80 80", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "event-location-outline-icon"
    ),
    React.createElement("path", { d: "M46.641 26.827c3.912-1.426 5.607.441 3.774 4.192L39.712 52.93c-1.827 3.741-4.275 3.545-5.62-.392 0 0-.779-4.114-3.664-7.318-2.885-3.205-6.895-4.41-6.895-4.41-3.802-1.682-3.724-4.2.198-5.63l22.91-8.354z", stroke: "#222", fill: "none", fillRule: "evenodd", strokeLinecap: "round" })
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/location-outline.svg?react-svg